import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProjectApi from "Api/ProjectApi/ProjectApi";
import {
  errorNotification,
  loadingNotification,
  successNotification,
  updateToError,
  updateToSuccessNotification,
} from "Components/MyNotification";

export const getBlanksThunk = createAsyncThunk(
  "blank/getAllBlanksForProject",
  async (data, thunkAPI) => {
    try {
      const { monthNumber, projectId } = data;

      if (!monthNumber) {
        errorNotification("Не переданий місяць");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!projectId) {
        errorNotification("Не переданий проект");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }

      const result = await ProjectApi.getBlanks(monthNumber, projectId);

      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      return result.dto;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const createBlankThunk = createAsyncThunk(
  "blank/createNewBlank",
  async (monthNumber, thunkAPI) => {
    const toastId = loadingNotification("Створення бланку...");
    try {
      const {
        description,
        blankMaterials,
        workDate,
        selectedWorks,
        users,
        startTime,
        endTime,
        currentBlankId,
      } = thunkAPI.getState().blank;
      const projectId = thunkAPI.getState().project.currentProjectId;
      if (!description) {
        updateToError(toastId, "Має бути заповнений опис робіт");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!workDate) {
        updateToError(toastId, "Має бути вибрана дата");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!selectedWorks.length) {
        updateToError(toastId, "Мають бути вибрані роботи");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!users.length) {
        updateToError(toastId, "Мають бути вибрані працівники");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!startTime || !endTime) {
        updateToError(toastId, "Має бути вказаний повний час робіт");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      const result = await ProjectApi.createBlank({
        description,
        blankMaterials,
        workDate,
        selectedWorks,
        users,
        projectId,
        startTime,
        endTime,
        blankId: currentBlankId,
      });

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      updateToSuccessNotification(toastId, "Створено новий бланк");
      thunkAPI.dispatch(getBlanksThunk({ monthNumber, projectId }));
      return result.dto;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка створення");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const editBlankThunk = createAsyncThunk(
  "blank/editCurrentBlank",
  async (_, thunkAPI) => {
    const toastId = loadingNotification("Оновлення бланку...");
    try {
      const {
        description,
        blankMaterials,
        startTime,
        endTime,
        workDate,
        selectedWorks,
        users,
        currentBlankId,
      } = thunkAPI.getState().blank;
      const projectId = thunkAPI.getState().project.currentProjectId;

      if (!startTime || !endTime) {
        updateToError(toastId, "Має бути заповнений час виконання робіт");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!description) {
        updateToError(toastId, "Має бути заповнений опис робіт");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!workDate) {
        updateToError(toastId, "Має бути вибрана дата");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!selectedWorks.length) {
        updateToError(toastId, "Мають бути вибрані роботи");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!users.length) {
        updateToError(toastId, "Мають бути вибрані працівники");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!currentBlankId) {
        updateToError(toastId, "Мають бути вибрани бланк");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      const result = await ProjectApi.updateBlank({
        id: currentBlankId,
        description,
        blankMaterials,
        startTime,
        endTime,
        workDate,
        selectedWorks,
        users,
        projectId,
      });

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      updateToSuccessNotification(toastId, "Оновлено бланк");
      return result.dto;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка оновлення");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const getSingleBlankThunk = createAsyncThunk(
  "blank/getSingleCurrentBlank",
  async (data, thunkAPI) => {
    try {
      const { blankId, projectId } = data;
      if (!blankId) {
        errorNotification("Має бути переданий ID бланку");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!projectId) {
        errorNotification("Має бути переданий ID проекту");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }

      const result = await ProjectApi.getSingleBlank(projectId, blankId);

      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      return result.dto;
    } catch (err) {
      errorNotification(err.message);
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const sendBlankThunk = createAsyncThunk(
  "blank/sendBlank",
  async (_, thunkAPI) => {
    const toastId = loadingNotification("Відправка бланку на нарахування...");
    try {
      const blankId = thunkAPI.getState().blank.currentBlankId;
      const projectId = thunkAPI.getState().project.currentProjectId;
      if (!blankId) {
        updateToError(toastId, "Має бути переданий ID бланку");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }
      if (!projectId) {
        updateToError(toastId, "Має бути переданий ID проекту");
        return thunkAPI.rejectWithValue("Не передані всі поля");
      }

      const result = await ProjectApi.sendBlank(blankId, projectId);

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      updateToSuccessNotification(toastId, "Бланк відправлено на нарахування");
      return blankId;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка відправки");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const onSaveDataThunk = createAsyncThunk(
  "blank/postBlankToSaveForProject",
  async (_, thunkAPI) => {
    const toastId = loadingNotification("Збереження бланку...");
    try {
      const {
        currentBlankId,
        startTime,
        endTime,
        description,
        workDate,
        users,
        selectedWorks,
        blankMaterials,
      } = thunkAPI.getState().blank;
      const { currentProjectId } = thunkAPI.getState().project;

      const result = await ProjectApi.saveBlankWeb({
        blankId: currentBlankId,
        startTime,
        endTime,
        description,
        workDate,
        users,
        selectedWorks,
        blankMaterials,
        projectId: currentProjectId,
        fromTelegram: true,
      });
      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      updateToSuccessNotification(toastId, "Збережено бланк");
    } catch (err) {
      updateToError(toastId, err.message || "Помилка при збереженні бланку");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const getSingleSavedBlankThunk = createAsyncThunk(
  "blank/getSingleSavedBlankFromProject",
  async (blankId, thunkAPI) => {
    try {
      const { currentProjectId } = thunkAPI.getState().project;

      const result = await ProjectApi.getSingleBlank(currentProjectId, blankId);
      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }

      return result.dto;
    } catch (err) {
      errorNotification(err.message || "Помилка при збереженні бланку");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const deleteBlankPermanently = createAsyncThunk(
  "blank/deletepermanently",
  async (_, thunkAPI) => {
    try {
      const { currentProjectId } = thunkAPI.getState().project;
      const { currentBlankId } = thunkAPI.getState().blank;

      const result = await ProjectApi.deleteBlank({
        blankId: currentBlankId,
        projectId: currentProjectId,
      });
      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      successNotification(result.dto);
      return currentBlankId;
    } catch (err) {
      errorNotification(err.message || "Помилка при видаленні бланку");
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const findUsersFromLastBlank = createAsyncThunk(
  "blank/findusersfromlastblank",
  async (_, thunkAPI) => {
    try {
      const { currentProjectId } = thunkAPI.getState().project;
      const result = await ProjectApi.findLastUsersToBlank(currentProjectId);
      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      return result.dto;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const initialState = {
  isComponentLoading: false,
  isDrawerLoading: false,
  isLoading: false,
  title: "",
  startTime: "",
  endTime: "",
  description: "",
  workDate: "",
  users: [],
  selectedWorks: [],
  projectBlanks: [],
  currentBlankId: null,
  currentBlankStatus: null,
  currentBlankCreatedAt: null,
  isSomeValueChanged: false,
  isFormAfterSave: false,
  blankMaterials: [],
  ///
  materialAndWorksConnections: {},
  // material : work
};
const BlankSlice = createSlice({
  name: "blank",
  initialState,
  reducers: {
    setIsFormAfterSave: (state, action) => {
      state.isFormAfterSave = action.payload;
    },
    setDrawerLoading: (state, action) => {
      state.isDrawerLoading = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setDescription: (state, action) => {
      state.description = action.payload;
      state.isSomeValueChanged = true;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
      state.isSomeValueChanged = true;
    },
    setDate: (state, action) => {
      state.workDate = action.payload;
      state.isSomeValueChanged = true;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
      state.isSomeValueChanged = true;
    },
    setSelectedWorks: (state, action) => {
      const isInState = state.selectedWorks.some(
        (el) => el.allowedWorkTypeId === action.payload.allowedWorkTypeId,
      );
      if (!isInState && !action.payload.fromDragger) {
        state.selectedWorks = action.payload;
      }
      if (!isInState && action.payload.fromDragger) {
        state.selectedWorks = [...state.selectedWorks, action.payload];
      }

      const materialsFromWorksArray = [];
      const materialsToInsert = [...state.selectedWorks]
        .filter((el) => {
          if (el.materialsForWork && el.materialsForWork.length) {
            return true;
          }
        })
        .forEach((el) =>
          el.materialsForWork.forEach((elem) => {
            materialsFromWorksArray.push(elem);
          }),
        );

      const materialsToInsertToBlankMaterials = materialsFromWorksArray.filter(
        (el) => {
          const isSaveMaterial = [...state.blankMaterials].some(
            (elem) => elem.id === el.id,
          );
          return !isSaveMaterial;
        },
      );

      state.blankMaterials = [
        ...state.blankMaterials,
        ...materialsToInsertToBlankMaterials,
      ];

      state.isSomeValueChanged = true;
    },
    setSelectedMaterials: (state, action) => {
      const isInState = state.blankMaterials.some(
        (el) => el.id === action.payload.id,
      );

      if (!isInState && !action.payload.fromDragger) {
        state.blankMaterials = action.payload;
      }
      if (!isInState && action.payload.fromDragger) {
        state.blankMaterials = [...state.blankMaterials, action.payload];
      }

      // if (!action.payload.length) {
      //   state.materialAndWorksConnections = {};
      // }

      //////
      // const keysToSave = action.payload
      //   .filter((el) => {
      //     return el.workTypeId;
      //   })
      //   .map((el) => el.workTypeId.id);
      // //keysToSave - це ті айді робіт що ми зберігаємо і не видаляємо

      // const connectionsToSave = Object.keys(
      //   state.materialAndWorksConnections,
      // ).reduce((acc, key) => {
      //   const el = state.materialAndWorksConnections[key];
      //   if (keysToSave.includes(el)) {
      //     acc[key] = el;
      //   }
      //   return acc;
      // }, {});
      // state.materialAndWorksConnections = connectionsToSave;

      // // робимо підписку у форматі - Айді матеріалу : Айді роботи
      // action.payload.forEach((el) => {
      //   if (el.workTypeTied) {
      //     if (!state.materialAndWorksConnections.hasOwnProperty(el.id)) {
      //       state.materialAndWorksConnections[el.id] =
      //         el.workTypeTied.allowedWorkTypeId;
      //     }
      //   }
      // });

      //
      //
      // const savedWorks = [...state.selectedWorks].filter((el) => {
      //   if (!el.connectionWithMaterial) {
      //     return true;
      //   }

      //   const isSaveThisWork = Object.values(
      //     state.materialAndWorksConnections,
      //   ).some((elem) => elem === el.allowedWorkTypeId);
      //   if (isSaveThisWork) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // });

      // state.selectedWorks = savedWorks;
      //
      //

      const worksToInsert = [...state.blankMaterials]
        .filter((el) => el.workTypeTied)
        .map((el) => el.workTypeTied)
        .filter((el) => {
          const isSaveElem = [...state.selectedWorks].some(
            (elem) => elem.allowedWorkTypeId === el.allowedWorkTypeId,
          );
          return !isSaveElem;
        });

      state.selectedWorks = [...state.selectedWorks, ...worksToInsert];
      // delete works if we delete materials
      // const worksToSave = [...state.selectedWorks, ...worksToInsert].filter(
      //   (el) => {
      //     if (!el.connectionWithMaterial) {
      //       return true;
      //     }
      //     const isNotDeleteWork = [...state.blankMaterials].some((elem) => {
      //       if (elem.workTypeTied) {
      //         if (
      //           elem.workTypeTied.allowedWorkTypeId === el.allowedWorkTypeId
      //         ) {
      //           return true;
      //         } else {
      //           return false;
      //         }
      //       } else {
      //         return true;
      //       }
      //     });

      //     if (isNotDeleteWork) {
      //       return true;
      //     }
      //     return false;
      //   },
      // );

      // state.selectedWorks = [...worksToSave];

      //
      //

      state.isSomeValueChanged = true;
    },
    setChangeMaterialsValue: (state, action) => {
      const { id, value } = action.payload;
      state.blankMaterials = [...state.blankMaterials].reduce((acc, el) => {
        if (el.id === id) {
          if (el.restCount >= value) {
            el.value = value;
            el.restCountAfterChanges = el.restCount;
            el.restCountAfterChanges = el.restCount - value;
          } else {
            errorNotification("Не можна ввести кількість більше залишку");
          }
        }
        acc.push(el);
        return acc;
      }, []);
    },
    setChangeValue: (state, action) => {
      const { allowedWorkTypeId, value } = action.payload;
      state.selectedWorks = [...state.selectedWorks].map((el) => {
        if (el.allowedWorkTypeId === allowedWorkTypeId) {
          // el.value = +value;
          el.value = value;
        }
        return el;
      });
      state.isSomeValueChanged = true;
    },
    setCommentData: (state, action) => {
      const { param, comment, typeContent } = action.payload;
      // param: item.allowedWorkTypeId || item.id,
      // comment: inputValue,
      // typeContent: 'material' || 'work',
      state.isSomeValueChanged = true;
      switch (typeContent) {
        case "material":
          state.blankMaterials = [...state.blankMaterials].map((elem) => {
            if (elem.id === param) {
              elem.comment = comment;
            }
            return elem;
          });
          break;
        case "work":
          state.selectedWorks = [...state.selectedWorks].map((elem) => {
            if (elem.allowedWorkTypeId === param) {
              elem.comment = comment;
            }
            return elem;
          });
          break;
      }
    },
    setReset: (state, action) => {
      state.title = "";
      state.description = "";
      state.workDate = "";
      state.users = [];
      state.selectedWorks = [];
      state.currentBlankId = null;
      state.currentBlankStatus = null;
      state.currentBlankCreatedAt = null;
      state.isSomeValueChanged = false;
      state.isComponentLoading = false;
      state.isLoading = false;
      state.isDrawerLoading = false;
      state.startTime = "";
      state.endTime = "";
      state.isFormAfterSave = false;
      state.blankMaterials = [];
      state.materialAndWorksConnections = {};
    },
    setIsValueChanged: (state, action) => {
      state.isSomeValueChanged = action.payload;
    },
    setWorkTime: (state, action) => {
      const { param, time } = action.payload;
      state[param] = time;
      state.isSomeValueChanged = true;
    },
    setBlankId: (state, action) => {
      state.currentBlankId = action.payload;
    },
    setValuesBySavedBlank: (state, action) => {
      const {
        startTime,
        endTime,
        description,
        workDate,
        users,
        selectedWorks,
        blankMaterials,
      } = action.payload;

      state.startTime = startTime;
      state.endTime = endTime;
      state.description = description;
      state.workDate = workDate;
      state.users = users;
      state.selectedWorks = selectedWorks;
      state.blankMaterials = blankMaterials;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBlankThunk.pending, (state, action) => {
      state.isComponentLoading = true;
      state.isDrawerLoading = true;
    });
    builder.addCase(createBlankThunk.fulfilled, (state, action) => {
      state.isComponentLoading = false;
      state.isDrawerLoading = false;
    });
    builder.addCase(createBlankThunk.rejected, (state, action) => {
      state.isComponentLoading = false;
      state.isDrawerLoading = false;
    });
    builder.addCase(editBlankThunk.pending, (state, action) => {
      state.isComponentLoading = true;
    });
    builder.addCase(editBlankThunk.fulfilled, (state, action) => {
      state.isComponentLoading = false;
      state.isSomeValueChanged = false;
    });
    builder.addCase(editBlankThunk.rejected, (state, action) => {
      state.isComponentLoading = false;
    });
    builder.addCase(getBlanksThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getBlanksThunk.fulfilled, (state, action) => {
      state.projectBlanks = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getBlanksThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getSingleBlankThunk.pending, (state, action) => {
      state.isComponentLoading = true;
    });
    builder.addCase(getSingleBlankThunk.fulfilled, (state, action) => {
      const {
        startTime,
        endTime,
        description,
        id,
        createdAt,
        status,
        selectedWorks,
        users,
        workDate,
        blankMaterials,
      } = action.payload;

      state.blankMaterials = blankMaterials;
      state.startTime = startTime;
      state.endTime = endTime;
      state.description = description;
      state.workDate = workDate;
      state.users = users;
      state.selectedWorks = selectedWorks;
      state.currentBlankId = id;
      state.currentBlankStatus = status;
      state.currentBlankCreatedAt = createdAt;
      state.isComponentLoading = false;
    });
    builder.addCase(getSingleBlankThunk.rejected, (state, action) => {
      state.isComponentLoading = false;
    });
    builder.addCase(sendBlankThunk.pending, (state, action) => {
      state.isComponentLoading = true;
    });
    builder.addCase(sendBlankThunk.fulfilled, (state, action) => {
      const blankId = action.payload;
      state.isComponentLoading = false;
      // state.currentBlankStatus = "облікований бланк";
      state.currentBlankStatus = "на нарахуванні";
      state.projectBlanks = [...state.projectBlanks].map((el) => {
        return Object.keys(el).reduce((acc, elem) => {
          acc[elem] = el[elem].map((e) => {
            if (e.id === blankId) {
              // e.status = "облікований бланк";
              e.status = "на нарахуванні";
              e.statusId = null;
            }
            return e;
          });

          return acc;
        }, {});
      });
    });
    builder.addCase(sendBlankThunk.rejected, (state, action) => {
      state.isComponentLoading = false;
    });
    builder.addCase(onSaveDataThunk.pending, (state, action) => {
      state.isDrawerLoading = true;
    });
    builder.addCase(onSaveDataThunk.fulfilled, (state, action) => {
      state.isDrawerLoading = false;
    });
    builder.addCase(onSaveDataThunk.rejected, (state, action) => {
      state.isDrawerLoading = false;
    });

    builder.addCase(getSingleSavedBlankThunk.pending, (state, action) => {
      state.isDrawerLoading = true;
    });
    builder.addCase(getSingleSavedBlankThunk.fulfilled, (state, action) => {
      state.isDrawerLoading = false;
      const {
        startTime,
        endTime,
        description,
        workDate,
        users,
        selectedWorks,
        blankMaterials,
      } = action.payload;

      state.blankMaterials = blankMaterials;
      state.startTime = startTime;
      state.endTime = endTime;
      state.description = description;
      state.workDate = workDate;
      state.users = users;
      state.selectedWorks = selectedWorks;
    });
    builder.addCase(getSingleSavedBlankThunk.rejected, (state, action) => {
      state.isDrawerLoading = false;
    });
    builder.addCase(deleteBlankPermanently.pending, (state, action) => {
      state.isComponentLoading = true;
    });
    builder.addCase(deleteBlankPermanently.fulfilled, (state, action) => {
      const blankId = action.payload;
      state.isComponentLoading = false;
      state.currentBlankStatus = "";
      state.projectBlanks = [...state.projectBlanks].map((el) => {
        return Object.keys(el).reduce((acc, elem) => {
          acc[elem] = el[elem].filter((e) => {
            if (e.id !== blankId) {
              return e;
            }
          });

          if (Object.keys(acc[elem]).length === 0) {
            delete acc[elem];
          }

          return acc;
        }, {});
      });
    });
    builder.addCase(deleteBlankPermanently.rejected, (state, action) => {
      state.isComponentLoading = false;
    });
    builder.addCase(findUsersFromLastBlank.fulfilled, (state, action) => {
      state.users = action.payload;
    });
  },
});
export const {
  setIsFormAfterSave,
  setSelectedWorks,
  setLoading,
  setDescription,
  setDate,
  setTitle,
  setUsers,
  setChangeValue,
  setReset,
  setIsValueChanged,
  setWorkTime,
  setDrawerLoading,
  setBlankId,
  setValuesBySavedBlank,
  setSelectedMaterials,
  setChangeMaterialsValue,
  setCommentData,
} = BlankSlice.actions;
export const selectBlank = (store) => store.blank;

export default BlankSlice.reducer;
